import { api } from '../lib/api';

interface LineLoginConfig {
  clientId: string;
  redirectUri: string;
  state: string;
  isStaff?: boolean;
}

export const useLineLogin = () => {
  const handleLogin = (config: LineLoginConfig) => {
    // stateをセッションストレージに保存（CSRF対策）
    sessionStorage.setItem('line_login_state', config.state);
    
    // LINE認証URLを直接構築
    api.lineLogin({
      clientId: config.clientId,
      redirectUri: config.redirectUri,
      state: config.state
    });
  };

  return {
    handleLogin,
  };
}; 